import './TestimonialCarouselCard.css';
import React from 'react';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ErrorBoundary from '../atoms/ErrorBoundary/ErrorBoundary';
import Video from '../atoms/Video';
const BASE_URL = process.env.REACT_APP_MEDIA_HOST ? process.env.REACT_APP_MEDIA_HOST : '';
export const TestimonialCarouselCard = props => {
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const imageSrc = BASE_URL ? `${BASE_URL}${props.image.jss.value.src}` : props.image.jss.value.src;
  const imageAlt = props.image.jss.value.alt;
  const video = props.video && props.video.jss.value;
  const renderHeader = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "testimonial-card__header"
    }, (props.title || props.authorName) && /*#__PURE__*/React.createElement("div", {
      className: "testimonial-card_title"
    }, props.title && /*#__PURE__*/React.createElement(Text, {
      tag: "h1",
      className: "testimonial-card__title",
      field: props.title.jss,
      "data-cy": "testimonial-card-media-title"
    }), props.authorName && /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: `testimonial-card__title testimonial-card__title--gray`,
      field: props.authorName.jss,
      "data-cy": "testimonial-card-media-subtitle"
    })));
  };
  const renderMedia = () => {
    if (!imageSrc) return null;
    return /*#__PURE__*/React.createElement("div", {
      className: "testimonial-card__media"
    }, /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
      media: "(min-width:769px)",
      srcSet: `${imageSrc}&cw=580&ch=435`
    }), /*#__PURE__*/React.createElement("img", {
      className: "testimonial-card__image",
      src: `${imageSrc}&cw=324&ch=243`,
      alt: imageAlt
    })), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(React.Fragment, null, video && video.href && /*#__PURE__*/React.createElement(Video, {
      videoSrc: video.href,
      videoType: video.linktype === 'external' ? 'external' : 'media',
      structuredScript: true,
      buttonTopRightAlignment: true,
      buttonFilled: true,
      click: props.onVideoBtnClick
    }))));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: props.params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `row testimonial-card testimonial-card-media ${props.inCarousel ? "testimonial-card--in-carousel" : ""}`,
    "data-cy": "testimonial-card-media"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card__photo-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card__photo testimonial-card__photo--large testimonial-card__video-parent testimonial-card__photo--desktop",
    "data-cy": "testimonial-card-media-media"
  }, renderMedia())), /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card__media-container-wrapper col-md-5 col-lg-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card-media-container"
  }, renderHeader(), /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card__info"
  }, props.authorDescription && /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "c-author__position",
    field: props.authorDescription.jss,
    "data-cy": "testimonial-card-media-author-description"
  }), /*#__PURE__*/React.createElement("div", {
    className: "testimonial-card__photo testimonial-card__photo--large testimonial-card__video-parent testimonial-card__photo--mobile",
    "data-cy": "testimonial-card-media-media"
  }, renderMedia()), /*#__PURE__*/React.createElement("div", {
    className: `testimonial-card__testimony ${props.hasQuoteMark && props.hasQuoteMark.jss.value ? 'testimonial-card__testimony--with-quotes' : ''}`
  }, props.quoteText && /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "c-testimony__text",
    field: props.quoteText.jss,
    "data-cy": "testimonial-card-media-quote"
  }))))))));
};
const StyledWrapper = _ref => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    componentTabIndex: "disabled"
  }, children);
};
const commonStyles = "cny5d1d";
const rtlStyles = "r1x0fo1y";
const ltrStyles = "lz2idtz";